// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-launch/MissionProgress.jsx

import React from 'react';
import ProgressTimeline from './shared/ProgressTimeline';
import AnimatedProgressStrip from './shared/AnimatedProgressStrip';

export default function MissionProgress({
  steps = [],
  activeStep = 0,
  highestReachedStep = activeStep,
  progress = 0,
  stepStatuses = {},
  onStepSelect,
}) {
  return (
    <aside className="mission-launch-progress-shell">
      <div className="mission-progress-brand">
        <span className="mission-progress-mark">O</span>
        <div>
          <p className="mission-launch-eyebrow">OASYS Mission Launch</p>
          <h2>Compliance Operations Center</h2>
        </div>
      </div>

      <AnimatedProgressStrip
        value={progress}
        label="Mission Progress"
      />

      <ProgressTimeline
        steps={steps}
        activeStep={activeStep}
        highestReachedStep={highestReachedStep}
        stepStatuses={stepStatuses}
        onStepSelect={onStepSelect}
      />
    </aside>
  );
}
